import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ApiGatewayUrl } from '../../src/appsettings';
import ErrorException from "src/components/ErrorException";
import Rest from '../../src/core/rest';

export const getACLCamerasByUser = createAsyncThunk(
  "mapView/getCameras",
  async () => {
    try {
      const response = await Rest.get(ApiGatewayUrl + '/videosensors');
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);


export const mapSlice = createSlice({
  name: 'map',
  initialState: {
    maps: [],
    selectedAgencyIds: [],
    filteredText: '',
    searchedCamsResult: [],
    isAllSelected: true,
    isLoading: false,
    isTagsEditing: false,
  },
  reducers: {
    selectedAgency: (state, action) => {
      state.selectedAgencyIds = [...state.selectedAgencyIds, action.payload];
    },
    unSelectedAgency: (state, action) => {
      state.selectedAgencyIds = state.selectedAgencyIds.filter(
        (id) => id != action.payload
      );
    },
    setSelectAllOpt: (state, action) => {
      state.isAllSelected = action.payload;
    },
    updateSelectAllAgencies: (state, action) => {
      state.selectedAgencyIds = action.payload;
    },
    setFilteredText: (state, action) => {
      state.filteredText = action.payload;
    },
    searchCamsByFilter: (state, action) => {
      state.searchedCamsResult = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getACLCamerasByUser.pending, (state) => {
        return { ...state, isLoading: true };
      })
      .addCase(getACLCamerasByUser.fulfilled, (state, action) => {
        return {
          ...state,
          cameras: action.payload,
          isLoading: false
        };
      })
      .addCase(getACLCamerasByUser.rejected, (state, action) => {
        return { ...state, errorMsg: action.error.message };
      })
  }
});

export const mapActions = mapSlice.actions;
export const mapState = (state) => state.map;
export default mapSlice.reducer;
